import { Messages } from '../../../../../codegen/Localize';
import { IDatasourceActions } from '../../../../../datasource/ServerApi/types/IDatasourceActions';
import { IAccelerationTaskInfo } from '../../../../../ts/models/IAccelerationTaskInfo';
import { IWorkbookActions } from '../../../../../workbook/ServerApi/types/IWorkbookActions';
import { deleteDataAccelerationTask } from '../../../../actions/spaces/dataAcceleration/DataAccelerationTaskMenuAction';
import { AppState } from '../../../../state/AppState';
import { currentUserIsAdmin } from '../../../../utils/MixedContentHelpers';
import { EntityActionNames, IEntityAction } from '../IEntityAction';

export const DeleteDataAccelerationTaskEntityAction: IEntityAction<IAccelerationTaskInfo, IWorkbookActions | IDatasourceActions> = {
  name: EntityActionNames.TasksDelete,
  translateName: Messages.delete_action,
  isVisible: () => true,
  isClickable: isClickable,
  createReduxAction: deleteDataAccelerationTask
};

function isClickable(
  availableActions: IWorkbookActions | IDatasourceActions,
  tasks: IAccelerationTaskInfo[],
  state: AppState
): boolean {
  return currentUserIsAdmin(state);
}
